import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 2025 Kunj Khanpara. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
